import React from 'react'

import { Helmet } from 'react-helmet'

import './testimonials.css'

const Testimonials = (props) => {
  return (
    <div className="testimonials-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="testimonials-testimonials">
        <div className="testimonials-frame121">
          <div className="testimonials-frame15">
            <div className="testimonials-frame162">
              <img
                alt="VectorI372"
                src="/external/vectori372-5izd.svg"
                className="testimonials-vector10"
              />
              <span className="testimonials-text10">futureheirs</span>
            </div>
            <div className="testimonials-frame81">
              <div className="testimonials-frame6">
                <span className="testimonials-text11">Home</span>
              </div>
              <div className="testimonials-frame7">
                <span className="testimonials-text12">About Us</span>
              </div>
              <div className="testimonials-frame82">
                <span className="testimonials-text13">Contact Us</span>
              </div>
              <div className="testimonials-frame9">
                <span className="testimonials-text14">Blog</span>
              </div>
            </div>
            <div className="testimonials-component41">
              <span className="testimonials-text15">Join Us</span>
            </div>
          </div>
          <div className="testimonials-frame131">
            <div className="testimonials-frame195">
              <img
                alt="Line651741"
                src="/external/line651741-fg07.svg"
                className="testimonials-line65"
              />
              <span className="testimonials-text16">Testimonials</span>
            </div>
            <span className="testimonials-text17">
              See how FutureHeirs is transforming lives! Hear from students,
              parents, and partners about the impact of our programs.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle41741"
          src="/external/rectangle41741-ca5g.svg"
          className="testimonials-rectangle4"
        />
        <div className="testimonials-frame223">
          <div className="testimonials-frame218">
            <span className="testimonials-text18">What Our Client Says</span>
            <span className="testimonials-text19">
              Real experiences, real impact. Here&apos;s what our clients have
              to say about working with us.
            </span>
          </div>
          <div className="testimonials-frame222">
            <div className="testimonials-component2">
              <div className="testimonials-frame219">
                <span className="testimonials-text20">Parents</span>
              </div>
              <div className="testimonials-frame220">
                <span className="testimonials-text21">Educators</span>
              </div>
              <div className="testimonials-frame221">
                <span className="testimonials-text22">Community Partners</span>
              </div>
            </div>
            <div className="testimonials-frame215">
              <div className="testimonials-frame213">
                <div className="testimonials-frame1341">
                  <div className="testimonials-frame1531">
                    <div className="testimonials-frame1591">
                      <img
                        alt="Ellipse51762"
                        src="/external/ellipse51762-3mas-200h.png"
                        className="testimonials-ellipse51"
                      />
                      <div className="testimonials-frame1521">
                        <span className="testimonials-text23">Michael</span>
                        <span className="testimonials-text24">
                          Program Graduate
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown10">
                      <div className="testimonials-vuesaxboldquotedown11">
                        <div className="testimonials-quotedown1">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-tfng.svg"
                            className="testimonials-vector11"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-fe4w.svg"
                            className="testimonials-vector12"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text25">
                    FutureHeirs didn&apos;t just teach me coding they showed me
                    how to use my skills to serve others. Now I&apos;m building
                    apps that help my community access resources they need.
                  </span>
                </div>
                <div className="testimonials-frame1481">
                  <div className="testimonials-frame1541">
                    <div className="testimonials-frame1592">
                      <img
                        alt="Ellipse61762"
                        src="/external/ellipse61762-c1d4-200h.png"
                        className="testimonials-ellipse61"
                      />
                      <div className="testimonials-frame1522">
                        <span className="testimonials-text26">Sarah</span>
                        <span className="testimonials-text27">
                          Scholarship Recipient
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown12">
                      <div className="testimonials-vuesaxboldquotedown13">
                        <div className="testimonials-quotedown2">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-h6kf.svg"
                            className="testimonials-vector13"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-omb.svg"
                            className="testimonials-vector14"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text28">
                    The mentors at FutureHeirs helped me see how my faith and my
                    passion for science could work together. I&apos;m now
                    studying biomedical engineering with a vision to bring
                    healthcare solutions to underserved areas.
                  </span>
                </div>
                <div className="testimonials-frame1511">
                  <div className="testimonials-frame1542">
                    <div className="testimonials-frame1593">
                      <img
                        alt="Ellipse61762"
                        src="/external/ellipse61762-r78c-200h.png"
                        className="testimonials-ellipse62"
                      />
                      <div className="testimonials-frame1523">
                        <span className="testimonials-text29">Gabriel</span>
                        <span className="testimonials-text30">
                          Program Graduate
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown14">
                      <div className="testimonials-vuesaxboldquotedown15">
                        <div className="testimonials-quotedown3">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-1x1.svg"
                            className="testimonials-vector15"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-912.svg"
                            className="testimonials-vector16"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text31">
                    FutureHeirs didn&apos;t just teach me coding they showed me
                    how to use my skills to serve others. Now I&apos;m building
                    apps that help my community access resources they need.
                  </span>
                </div>
              </div>
              <div className="testimonials-frame214">
                <div className="testimonials-frame1482">
                  <div className="testimonials-frame1543">
                    <div className="testimonials-frame1594">
                      <img
                        alt="Ellipse61762"
                        src="/external/ellipse61762-b79w-200h.png"
                        className="testimonials-ellipse63"
                      />
                      <div className="testimonials-frame1524">
                        <span className="testimonials-text32">Sarah</span>
                        <span className="testimonials-text33">
                          Scholarship Recipient
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown16">
                      <div className="testimonials-vuesaxboldquotedown17">
                        <div className="testimonials-quotedown4">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-e41o.svg"
                            className="testimonials-vector17"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-30ek.svg"
                            className="testimonials-vector18"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text34">
                    The mentors at FutureHeirs helped me see how my faith and my
                    passion for science could work together. I&apos;m now
                    studying biomedical engineering with a vision to bring
                    healthcare solutions to underserved areas.
                  </span>
                </div>
                <div className="testimonials-frame1512">
                  <div className="testimonials-frame1544">
                    <div className="testimonials-frame1595">
                      <img
                        alt="Ellipse61762"
                        src="/external/ellipse61762-rxtn-200h.png"
                        className="testimonials-ellipse64"
                      />
                      <div className="testimonials-frame1525">
                        <span className="testimonials-text35">Gabriel</span>
                        <span className="testimonials-text36">
                          Program Graduate
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown18">
                      <div className="testimonials-vuesaxboldquotedown19">
                        <div className="testimonials-quotedown5">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-8dvn.svg"
                            className="testimonials-vector19"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-8yde.svg"
                            className="testimonials-vector20"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text37">
                    FutureHeirs didn&apos;t just teach me coding they showed me
                    how to use my skills to serve others. Now I&apos;m building
                    apps that help my community access resources they need.
                  </span>
                </div>
                <div className="testimonials-frame1342">
                  <div className="testimonials-frame1532">
                    <div className="testimonials-frame1596">
                      <img
                        alt="Ellipse51762"
                        src="/external/ellipse51762-opvw-200h.png"
                        className="testimonials-ellipse52"
                      />
                      <div className="testimonials-frame1526">
                        <span className="testimonials-text38">Michael</span>
                        <span className="testimonials-text39">
                          Program Graduate
                        </span>
                      </div>
                    </div>
                    <div className="testimonials-vuesaxboldquotedown20">
                      <div className="testimonials-vuesaxboldquotedown21">
                        <div className="testimonials-quotedown6">
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-c0lq.svg"
                            className="testimonials-vector21"
                          />
                          <img
                            alt="Vector1762"
                            src="/external/vector1762-y1g6.svg"
                            className="testimonials-vector22"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="testimonials-text40">
                    FutureHeirs didn&apos;t just teach me coding they showed me
                    how to use my skills to serve others. Now I&apos;m building
                    apps that help my community access resources they need.
                  </span>
                </div>
              </div>
            </div>
            <div className="testimonials-component3">
              <span className="testimonials-text41">Previous</span>
              <div className="testimonials-frame246"></div>
              <span className="testimonials-text42">Next</span>
            </div>
          </div>
        </div>
        <div className="testimonials-frame217">
          <div className="testimonials-frame190">
            <div className="testimonials-group39">
              <img
                alt="Rectangle19304"
                src="/external/rectangle19304-0rso-1100w.png"
                className="testimonials-rectangle1"
              />
              <div className="testimonials-grid">
                <div className="testimonials-group34">
                  <img
                    alt="Line519304"
                    src="/external/line519304-a3b9.svg"
                    className="testimonials-line51"
                  />
                  <img
                    alt="Line529304"
                    src="/external/line529304-jd6k.svg"
                    className="testimonials-line52"
                  />
                  <img
                    alt="Line539304"
                    src="/external/line539304-t0fs.svg"
                    className="testimonials-line53"
                  />
                  <img
                    alt="Line549304"
                    src="/external/line549304-wjln.svg"
                    className="testimonials-line54"
                  />
                  <img
                    alt="Line559304"
                    src="/external/line559304-fe2u.svg"
                    className="testimonials-line55"
                  />
                  <img
                    alt="Line569304"
                    src="/external/line569304-i7js.svg"
                    className="testimonials-line56"
                  />
                  <img
                    alt="Line579304"
                    src="/external/line579304-t6us.svg"
                    className="testimonials-line57"
                  />
                </div>
                <div className="testimonials-group33">
                  <img
                    alt="Line369304"
                    src="/external/line369304-48o6.svg"
                    className="testimonials-line36"
                  />
                  <img
                    alt="Line379304"
                    src="/external/line379304-ky47.svg"
                    className="testimonials-line37"
                  />
                  <img
                    alt="Line389304"
                    src="/external/line389304-f51f.svg"
                    className="testimonials-line38"
                  />
                  <img
                    alt="Line399304"
                    src="/external/line399304-shn.svg"
                    className="testimonials-line39"
                  />
                </div>
              </div>
              <img
                alt="childrenelectronicdevicesgadgetsconceptsmartconfid9304"
                src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid9304-lxv-500h.png"
                className="testimonials-childrenelectronicdevicesgadgetsconceptsmartconfid"
              />
            </div>
            <div className="testimonials-frame122">
              <div className="testimonials-frame132">
                <span className="testimonials-text43">
                  Subscribe to our Newsletter
                </span>
                <span className="testimonials-text44">
                  Join our community of supporters and stay updated on how
                  we&apos;re empowering the next generation of leaders.
                </span>
              </div>
              <div className="testimonials-cta">
                <div className="testimonials-frame3">
                  <span className="testimonials-text45">example@gmail.com</span>
                </div>
                <div className="testimonials-component42">
                  <span className="testimonials-text46">Subscribe</span>
                </div>
              </div>
            </div>
          </div>
          <div className="testimonials-frame189">
            <div className="testimonials-frame184">
              <div className="testimonials-group107">
                <span className="testimonials-text47">Company</span>
                <div className="testimonials-frame2491">
                  <span className="testimonials-text48">Home</span>
                  <span className="testimonials-text49">About Us</span>
                  <span className="testimonials-text50">Contact Us</span>
                  <span className="testimonials-text51">Programs</span>
                  <span className="testimonials-text52">Approach</span>
                </div>
              </div>
              <div className="testimonials-group106">
                <span className="testimonials-text53">Quick Links</span>
                <div className="testimonials-frame2492">
                  <span className="testimonials-text54">Partner with Us</span>
                  <span className="testimonials-text55">Volunteer</span>
                  <span className="testimonials-text56">Donate</span>
                  <span className="testimonials-text57">Blog</span>
                </div>
              </div>
              <div className="testimonials-group105">
                <span className="testimonials-text58">Terms and Policies</span>
                <div className="testimonials-frame248">
                  <span className="testimonials-text59">Privacy Policy</span>
                  <span className="testimonials-text60">
                    Terms and Conditions
                  </span>
                  <span className="testimonials-text61">Feedback</span>
                  <span className="testimonials-text62">FAQs</span>
                </div>
              </div>
              <div className="testimonials-group104">
                <span className="testimonials-text63">Contact Information</span>
                <div className="testimonials-group87">
                  <span className="testimonials-text64">
                    connect@futureheirs.org
                  </span>
                  <div className="testimonials-vuesaxboldsms1">
                    <div className="testimonials-vuesaxboldsms2">
                      <div className="testimonials-sms">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-4xrs.svg"
                          className="testimonials-vector23"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="testimonials-group88">
                  <span className="testimonials-text65">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="testimonials-vuesaxboldlocation1">
                    <div className="testimonials-vuesaxboldlocation2">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-4qbh.svg"
                        className="testimonials-vector24"
                      />
                    </div>
                  </div>
                </div>
                <div className="testimonials-group89">
                  <span className="testimonials-text66">(555) 123-4567</span>
                  <div className="testimonials-vuesaxboldcall1">
                    <div className="testimonials-vuesaxboldcall2">
                      <div className="testimonials-call">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-8f66.svg"
                          className="testimonials-vector25"
                        />
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-zinq.svg"
                          className="testimonials-vector26"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I208"
              src="/external/line2i208-2v9.svg"
              className="testimonials-line2"
            />
            <div className="testimonials-frame183">
              <div className="testimonials-frame161">
                <img
                  alt="VectorI208"
                  src="/external/vectori208-82de.svg"
                  className="testimonials-vector27"
                />
                <span className="testimonials-text67">futureheirs</span>
              </div>
              <div className="testimonials-frame180">
                <span className="testimonials-text68">Follow Us:</span>
                <div className="testimonials-frame177">
                  <div className="testimonials-vuesaxboldfacebook1">
                    <div className="testimonials-vuesaxboldfacebook2">
                      <div className="testimonials-facebook">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-i63k.svg"
                          className="testimonials-vector28"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI208"
                    src="/external/riinstagramfilli208-iinv.svg"
                    className="testimonials-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI208"
                    src="/external/pajamaslinkedini208-ebs4.svg"
                    className="testimonials-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI208"
                    src="/external/fa6brandssquarextwitteri208-qna5h.svg"
                    className="testimonials-fa6brandssquarextwitter"
                  />
                  <div className="testimonials-vuesaxboldyoutube1">
                    <div className="testimonials-vuesaxboldyoutube2">
                      <div className="testimonials-youtube">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-po8.svg"
                          className="testimonials-vector29"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
